import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class LanguageButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            languages: [],
            lang: 'en',
            market: ''
        };
    };

    componentWillMount() {

    }

    componentDidMount(){
        this.setState({
            lang: this.props.lang,
            market: this.props.market
        }, () => {
            this.update.language();
            this.update.languages();
        })
    }

    componentWillReceiveProps(nextProps, nextState){
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market
        })
    }

    update = {
        language: () => {
            this.setState({
                lang: this.state.lang
            });
        },
        languages: () => {
            let languages = JSON.parse(salesChannelRegister.get('languages'));
            if(Array.isArray(languages)){
                this.setState({languages: languages});
            }
        }
    };

    functions = {
        lang: (item) => {
            this.setState({lang: item, dropdown: false}, () => {
                this.props.history.push({
                    pathname: '/' + this.state.market + '/' + item
                });
                window.location.reload(false);
            });
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("mobile-menu", item, this.state.lang);
        },
        language: (item) => {
            try{
                let value = "";
                for(let i = 0; i < this.state.languages.length; i++){
                    if(this.state.languages[i].code === item){
                        value = this.state.languages[i].names[this.state.lang];
                    }
                }
                return value;
            }catch (e) {}
        }
    };

    renderYieldlock(){
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        }catch (e) {
            return false
        }
    };

    renderYieldspotter(){
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        }catch (e) {
            return false
        }
    };

    render() {
        return (
            <div>
                {
                    this.state.dropdown &&
                    <div onClick={() => this.setState({dropdown: false})} className={Styles.languageButtonContainerOverlay}/>
                }
                <div className={Styles.languageButtonContainer}>
                    <div style={this.renderYieldlock() || this.renderYieldspotter()?{color: '#00273A'}:{}} onClick={() => this.setState({dropdown: !this.state.dropdown})} className={Styles.languageButton}>
                        {this.state.lang}
                    </div>
                    {
                        this.state.dropdown &&
                        <div>
                            <div style={this.renderYieldlock() || this.renderYieldspotter()?{background: '#00273A'}:{}} className={Styles.languageButtonDropdown}>
                                {
                                    this.state.languages.map((item) => {
                                        return(
                                            <div onClick={() => this.functions.lang(item.code)} className={Styles.languageButtonDropdownItem}>
                                                {item.name}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={this.renderYieldlock() || this.renderYieldspotter()?{borderBottomColor: '#00273A'}:{}} className={Styles.languageButtonTriangle}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default LanguageButton;


// WEBPACK FOOTER //
// ./src/components/language-button/component.js